import {gsap} from 'gsap'
import React, {useEffect, useRef} from 'react'

import {makeEditable, tailwindConfig} from '@/common/utils'

import KeyFiguresItem from './KeyFiguresItem'

const KeyFigures = ({items = [], _editable}) => {
  const sectionRef = useRef()

  useEffect(() => {
    const container = sectionRef.current
    if (container) {
      const mm = gsap.matchMedia()
      mm.add(
        `(min-width: ${tailwindConfig.theme.screens['lg']})`,
        () => {
          gsap.fromTo(
            'path',
            {drawSVG: '0%'},
            {
              drawSVG: '100%',
              scrollTrigger: {
                trigger: container,
                start: 'center bottom',
              },
            }
          )
        },
        container
      )
      return () => mm.revert()
    }
  }, [])

  return (
    <section
      ref={sectionRef}
      {...makeEditable(_editable)}
      className='relative my-9 rounded-2xl bg-yellow-300 p-14 md:mt-12'
    >
      <DoodleArrow aria-hidden className='absolute right-0 -top-8 z-10 hidden md:block' />

      {items.length > 0 && (
        <ul className='flex flex-col justify-center gap-9 p-0 text-center md:flex-row'>
          {items.map((props) => (
            <KeyFiguresItem key={props._uid} {...props} />
          ))}
        </ul>
      )}
    </section>
  )
}

const DoodleArrow = (props) => (
  <svg
    width='62'
    height='102'
    viewBox='0 0 62 102'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M59.7701 0.964284C59.9808 0.45378 60.5655 0.210758 61.076 0.42148C61.5865 0.632203 61.8295 1.21687 61.6188 1.72738L59.7701 0.964284ZM4.81219 20.7271L5.80888 20.8085L4.81219 20.7271ZM0.828748 96.4441C0.370753 96.1355 0.249677 95.514 0.558317 95.056L5.5879 87.5925C5.89654 87.1345 6.51802 87.0135 6.97602 87.3221C7.43401 87.6307 7.55509 88.2522 7.24645 88.7102L2.77571 95.3444L9.4099 99.8152C9.86789 100.124 9.98897 100.745 9.68033 101.203C9.37169 101.661 8.75021 101.782 8.29221 101.474L0.828748 96.4441ZM61.6188 1.72738C58.1118 10.2236 52.5768 18.7873 46.3195 26.0817C40.0676 33.3699 33.0453 39.4484 26.5302 42.9248C20.086 46.3634 13.7585 47.4366 9.28897 43.9391C7.07511 42.2067 5.46013 39.4455 4.52269 35.621C3.58591 31.7991 3.30889 26.8533 3.81551 20.6458L5.80888 20.8085C5.31253 26.8903 5.59715 31.6034 6.46519 35.1448C7.33258 38.6836 8.7656 40.99 10.5215 42.364C13.9915 45.0793 19.2906 44.521 25.5886 41.1603C31.8157 37.8376 38.6513 31.9491 44.8015 24.7795C50.9464 17.6161 56.3578 9.23095 59.7701 0.964284L61.6188 1.72738ZM3.81551 20.6458C4.46088 12.7382 6.49481 7.44624 9.56496 4.47224C12.7073 1.42834 16.7505 0.979792 20.9043 2.34405C25.017 3.69483 29.3144 6.83152 33.2597 11.0955C37.2162 15.3717 40.8737 20.8405 43.6884 26.9504C49.3081 39.1493 51.6354 54.0653 46.0485 67.2351C40.4395 80.4568 26.9721 91.6493 1.57881 96.5964L1.19637 94.6333C26.1588 89.7701 38.9352 78.8817 44.2073 66.454C49.5014 53.9744 47.3471 39.6724 41.8719 27.7872C39.139 21.855 35.5957 16.5651 31.7917 12.4538C27.9764 8.33029 23.9537 5.4507 20.2802 4.24418C16.6477 3.05113 13.4388 3.50426 10.9565 5.90877C8.40208 8.38319 6.4391 13.0864 5.80888 20.8085L3.81551 20.6458Z'
      fill='#7F6AFF'
    />
  </svg>
)

export default KeyFigures
